import { Box, HStack } from "@chakra-ui/react";
import moment from "moment";
import { useContext } from "react";
import { ActionMeta, PropsValue } from "react-select";
import { Select } from "src/components/styled";
import { Option } from "src/components/styled/Form/Select";
import { useTheme } from "src/hooks/useTheme";
import { FullServiceContext } from "./context";

export const YearSwitcher = () => {
  const theme = useTheme();
  const { year, setYear } = useContext(FullServiceContext);

  const currentYear = moment().year();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

  const options: Option[] = years.map((year) => ({
    value: year.toString(),
    label: year.toString(),
  }));

  const selectedValue: PropsValue<Option> = {
    value: year.taxYear,
    label: year.taxYear,
  };

  return (
    <HStack justify="center" alignItems="center">
      <Box width="100px">
        <Select
          value={selectedValue}
          options={options}
          selectProps={{
            onChange: (newValue: unknown, actionMeta: ActionMeta<unknown>) => {
              if (
                newValue &&
                typeof newValue === "object" &&
                "value" in newValue
              ) {
                const option = newValue as Option;
                setYear(option.value.toString());
              }
            },
          }}
          containerStyle={{
            width: "100%",
            marginBottom: 0,
          }}
        />
      </Box>
    </HStack>
  );
};
